// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__2GCFZ","description":"PatientConsentPreview_description__3zXiE"};